import React, { useState } from 'react';
import styles from './ImageGallery.module.scss';

interface ImageGalleryProps {
  images: string[];
}

export default function ImageGallery({ images }: ImageGalleryProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      setIsTransitioning(false);
    }, 250);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      setIsTransitioning(false);
    }, 250);
  };

  return (
    <div className={styles.gallery}>
      <div className={styles.slideContainer}>
        {images.map((image, index) => (
          <div 
            key={index}
            className={`${styles.slide} ${index === currentIndex ? styles.active : ''} ${isTransitioning ? styles.transitioning : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
        <button className={`${styles.arrow} ${styles.prev}`} onClick={prevSlide}>
          ‹
        </button>
        <button className={`${styles.arrow} ${styles.next}`} onClick={nextSlide}>
          ›
        </button>
      </div>
    </div>
  );
}